import Vue from 'vue'
import Router from 'vue-router'
import App from '@/App'
import Phone from '@/pages/phonedraw'
import Sign from '@/pages/signaturePadBig'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
		path: '/',
		component: Phone,
		children: [
			// {
			// 	path: '/sign',
			// 	component: Sign,
			// 	name: 'sign'
			// },
			// 	{
			// 		path: '/qrcode',
			// 		component: Qrcode,
			// 		name: 'qrcode'
			// 	},
			// 	{
			// 		path: '/phone',
			// 		component: Phone,
			// 		name: 'phone'
			// 	}
		]
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js